module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/corporate-retail-530423ffafca7b9217919e8b18cf772c.jpg";